import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import Loading from "atoms/Loading"

const Wrapper = styled.div`
  position: relative;
`

const OverlayWrapper = styled.div`
  align-items: center;
  display: flex;
  font-family: Lato;
  justify-content: center;
  position: ${({ inline }) => (inline ? "relative" : "absolute")};
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  min-height: 25px;
`

const LoadingOverlay = ({ text = "Loading SpokenLayer Player", inline = false }) => (
  <OverlayWrapper inline={inline}>
    {text}
    {"\u00a0"}
    <Loading />
  </OverlayWrapper>
)

LoadingOverlay.propTypes = {
  text: PropTypes.string,
  inline: PropTypes.bool,
}

export default LoadingOverlay



// WEBPACK FOOTER //
// ./src/components/molecules/LoadingOverlay/index.js